import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SpendChangeHasPendingService } from '../spend-change-has-pending.service';

@Component({
  selector: 'app-spend-change-banner',
  templateUrl: './spend-change-banner.component.html',
  styleUrls: ['./spend-change-banner.component.scss'],
})
export class SpendChangeBannerComponent implements OnInit {
  private router = inject(Router);
  private spendChangeHasPendingService = inject(SpendChangeHasPendingService);

  hasPendingChangeRequests$: Observable<boolean>;

  ngOnInit(): void {
    this.hasPendingChangeRequests$ = this.spendChangeHasPendingService.HasPendingChangeRequests;
  }

  routeToSpendChangeRequests(): void {
    this.router.navigate(['/changerequests']);
  }
}
